import { cva } from 'class-variance-authority';

export const cvaStartDate = cva([
  'StartDateStyles-cvaStartDate',
  'absolute  bottom-0 z-50',
  'overflow-hidden',
  'h-full w-full',
  'bg-cBlack ',
]);
